// ProfitAndLoss.tsx
import Summary from "./Summaries";
import { DetailedCharts } from "./Detailedcharts";
import { withUIProtection } from "../../hoc/withUIProtection";
import { PropsWithChildren } from "react";
import { Expanse } from "./charts/Expanse";
import { Revenue } from "./charts/Revenue";
import { AccountingProvider } from "../../providers/AccountingProvider";

type Props = PropsWithChildren & {
  asContainer?: boolean;
};

const Accounting = ({ children, asContainer = true, ...rest }: Props) => {
  return (
    <AccountingProvider {...rest}>
      <div data-name="dashboard" className="space-y-6">
        {children}
      </div>
    </AccountingProvider>
  );
};

// Create protected versions of all components
const ProtectedSummary = withUIProtection(Summary);
const ProtectedDetailedCharts = withUIProtection(DetailedCharts);
const ProtectedExpanse = withUIProtection(Expanse);
const ProtectedRevenue = withUIProtection(Revenue);

// Attach protected subComponents to the main component
(Accounting as any).Summaries = ProtectedSummary;
(Accounting as any).DetailedCharts = ProtectedDetailedCharts;
(Accounting as any).Expanse = ProtectedExpanse;
(Accounting as any).Revenue = ProtectedRevenue;

// Export the protected component
export { Accounting };

// Export individual protected components
export {
  ProtectedSummary as Summaries,
  ProtectedDetailedCharts as DetailedCharts,
  ProtectedExpanse as Expanse,
  ProtectedRevenue as Revenue,
};
